import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import ConfigurationWarning from '../components/common/ConfigurationWarning';

// Import the tab components
import SyncOperationsTab from '../components/pricing-sync/SyncOperationsTab';
import SettingsTab from '../components/pricing-sync/SettingsTab';
import SyncedPricingTab from '../components/pricing-sync/SyncedPricingTab';
import ComponentSelector from '../components/pricing-sync/ComponentSelector';

export default function PricingSync() {
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/pricing-sync/pricing')) return 1;
    if (path.includes('/pricing-sync/settings')) return 2;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when the location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  return (
    <Box>
      <PageHeader
        title='Price Synchronization'
        subtitle='Sync price from your ERP system to Shopify'
      />

      <ConfigurationWarning>
        <ComponentSelector />

        {/* Render the active tab content */}
        {activeTab === 0 && <SyncOperationsTab />}
        {activeTab === 1 && <SyncedPricingTab />}
        {activeTab === 2 && <SettingsTab />}
      </ConfigurationWarning>
    </Box>
  );
}
